import React, { FC } from 'react';
import { LoadingRectangle } from 'style/styled-components/reusable.css';
import { CardWrapper } from 'components/Lane/Lane.css';
import { cardVariantCss } from 'components/Cards/Card/Card.css';
import { CardVariant, cardSpec } from 'components/Cards/Card/cardVariants';
import { ChannelBundleWrapper } from './CardChannel.css';

export const CardChannelLoading: FC = () => (
    <CardWrapper width={'auto'} height={'auto'} variantCss={cardVariantCss(cardSpec(CardVariant.CHANNEL))}>
        <LoadingRectangle />
    </CardWrapper>
);

export const ChannelBundleLoading: FC = () => (
    <ChannelBundleWrapper>
        <CardChannelLoading key={'line-1'} />
        <CardChannelLoading key={'line-2'} />
    </ChannelBundleWrapper>
);
